import api from "./api";

export const STORAGE_OPEN_FORNECEDOR = "econdo_open_fornecedor_id";

const qs = (p) => new URLSearchParams(Object.entries(p).filter(([, v]) => v !== "" && v !== undefined && v !== null));

const fornecedoresService = {
  listar:           (p = {}) => api("GET", `/fornecedores?${qs(p)}`),
  stats:            (p = {}) => api("GET", `/fornecedores/stats?${qs(p)}`),
  listarRamos:      (p = {}) => api("GET", `/fornecedores/ramos?${qs(p)}`),
  listarSelect:     (p = {}) => api("GET", `/fornecedores/select?${qs(p)}`),
  buscarPorId:      (id)     => api("GET", `/fornecedores/${id}`),
  criar:            (data)   => api("POST", "/fornecedores", data),
  atualizar:        (id, data) => api("PUT", `/fornecedores/${id}`, data),
  alterarSituacao:  (id, situacao) => api("PATCH", `/fornecedores/${id}/situacao`, { situacao }),
  deletar:          (id)     => api("DELETE", `/fornecedores/${id}`),
};

export default fornecedoresService;
